import type { PeoPayrollProviderCompanyType, SignUpMethod } from 'src/api';

export const PeoPayrollProviderSettingsFormFields = {
  companyType: 'companyType',
  signUpMethod: 'signUpMethod',
  pinHint: 'pinHint',
} as const;

export type PeoPayrollProviderSettingsFormValues = {
  [PeoPayrollProviderSettingsFormFields.companyType]: PeoPayrollProviderCompanyType;
  [PeoPayrollProviderSettingsFormFields.signUpMethod]: SignUpMethod;
  [PeoPayrollProviderSettingsFormFields.pinHint]?: string | null;
};
